/**
 * Convert a string to a URL-friendly slug
 * Handles Swedish characters (å, ä, ö, Å, Ä, Ö) and removes special characters
 */
export const slugify = (text: string): string => {
  return text
    .toLowerCase()
    .replace(/[åÅ]/g, 'a')
    .replace(/[äÄ]/g, 'a')
    .replace(/[öÖ]/g, 'o')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};
